
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcIconButton as ObcIconButtonElement} from '@oicl/openbridge-webcomponents/dist/components/icon-button/icon-button.js';
 
 
 

 
 export const ObcIconButton = createComponent({
   react: React,
   tagName: 'obc-icon-button',
   elementClass: ObcIconButtonElement,
   events: {
     
   }
  });
 
 